export const tabs = {
    announcements: {
      label: "공지사항",
      board_idx: 1,
      icon: "check",
      data: null,
      prefix: "[공지]",
    },
    events: {
      label: "일정정보",
      icon: "event",
      data: null,
      prefix: "|",
      isLoding: false,
    },
    memberNews: {
      label: "회원소식",
      board_idx: 2,
      icon: "notifications_active",
      data: null,
    },
  };
  